/**
 * Professional status selector component
 * Radio button group for selecting professional status
 */

import React from 'react';
import { RadioGroup, RadioGroupItem } from './ui/radio-group';
import { Label } from './ui/label';
import { STATUS_LABELS } from '../constants/salaryConstants';

const StatusSelector = ({ value, onChange }) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium text-slate-700">Statut professionnel</Label>
      <RadioGroup value={value} onValueChange={onChange} className="grid grid-cols-1 gap-1">
        {Object.entries(STATUS_LABELS).map(([key, label]) => (
          <div key={key} className="flex items-center space-x-2 p-1 rounded hover:bg-slate-50 transition-colors">
            <RadioGroupItem value={key} id={key} className="text-blue-600" />
            <Label htmlFor={key} className="cursor-pointer text-sm">{label}</Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
};

export default StatusSelector;